type Params = {
    query: string;
    addSearchTerm: (value: string) => void;
    resetParametersBeforeRequest: () => void;
    setSearchType: (type: string) => void;
    setSearchQueryOutput: () => void;
    getSearchData: () => void;
};

export const useSearchSubmit = (
    {
        query,
        addSearchTerm,
        resetParametersBeforeRequest,
        setSearchType,
        setSearchQueryOutput,
        getSearchData,
    }: Params
) => {
    const submitSearch = () => {
        resetParametersBeforeRequest();

        addSearchTerm(query);

        setSearchType("search");

        setSearchQueryOutput();

        getSearchData();
    };

    return {
        submitSearch,
    };
};
